import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  query: gql`
    query getClient(
      $clientId: String!
      $companyId: ID!
      $getPerson: Boolean!
      $getCompany: Boolean!
    ) {
      clients(search: $clientId, searchBy: CLIENT_ID)
        @include(if: $getPerson)
        @skip(if: $getCompany) {
        id: clientId
        clientId
        clientName
        birthDate
        phone
        email
        passportDoc
        passportSer
        passportNum
        passportDate
        passportPlace
        passportCode
        address
        passWord
        phone2
        phone3
        address2
        # blockComment
      }
      companies(companyId: $companyId)
        @include(if: $getCompany)
        @skip(if: $getPerson) {
        companyId
        companyName
        companyFullName
        inn
        currentRow
        totalRows
      }
    }
  `,
  config: {
    skip: (ownProps) => ownProps.skip,
    options: ({ type, id }) => {
      return {
        variables: {
          getPerson: type === "PERSON",
          getCompany: type === "COMPANY",
          clientId: id,
          companyId: id,
        },
      };
    },
  },
  propTypes: {
    type: PropTypes.oneOf(["PERSON", "COMPANY"]).isRequired,
    id: PropTypes.string.isRequired,
  },
  isLoaded: (data) => {
    return !!data.companies || !!data.client;
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/client.js